<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.1818 10.5455C19.1818 10.5455 18.3636 11.3636 18.3636 12.3636V15.0909H5.63636V12.3636C5.63636 11.3636 4.82727 10.5455 3.81818 10.5455C2.80909 10.5455 2 11.3636 2 12.3636V16.9091C2 17.9091 2.81818 18.7273 3.81818 18.7273H20.1818C21.1818 18.7273 22 17.9091 22 16.9091V12.3636C22 11.3636 21.1818 10.5455 20.1818 10.5455ZM17.4545 6H6.54545C5.54545 6 4.72727 6.81818 4.72727 7.81818V9.77273C5.78182 10.1455 6.54545 11.1545 6.54545 12.3273V14.1818H17.4545V12.3364C17.4545 11.1545 18.2182 10.1545 19.2727 9.78182V7.81818C19.2727 6.81818 18.4545 6 17.4545 6Z"
      fill="currentColor"
    />
  </svg>
</template>
